import type { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { availablePlansGuard } from './guards/available-plans.guard';
import { retailCostsSelectedGuard } from './guards/retail-costs-selected.guard';
import { selectedDrugGuard } from './guards/selected-drug.guard';
import { selectedDrugsGuard } from './guards/selected-drugs.guard';
import { selectedPharmacyForDetailsGuard } from './guards/selected-pharmacy-for-details.guard';
import { selectedPlanGuard } from './guards/selected-plan.guard';
import { selectedZipGuard } from './guards/selected-zip.guard';

export const routes: Routes = [
  {
    path: 'Home',
    canActivate: [authGuard],
    loadComponent: async () => await import('./features/home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'SelectPlan',
    canActivate: [authGuard, selectedZipGuard, availablePlansGuard],
    loadComponent: async () => await import('./features/select-plan/select-plan.component').then(m => m.SelectPlanComponent)
  },
  {
    path: 'Resources/Terms',
    loadComponent: async () => await import('./features/terms-of-service/terms-of-service.component').then(m => m.TermsOfServiceComponent)
  },
  {
    path: 'Resources/PrivacyPolicy',
    loadComponent: async () => await import('./features/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
  },
  {
    path: 'Resources/FAQ',
    loadComponent: async () => await import('./features/faq/faq.component').then(m => m.FaqComponent)
  },
  {
    path: 'Resources/AccessibilityStatement',
    loadComponent: async () =>
      await import('./features/accessibility-statement/accessibility-statement.component').then(m => m.AccessibilityStatementComponent)
  },
  {
    path: 'Account/Prescriptions',
    canActivate: [authGuard, selectedZipGuard, selectedPlanGuard],
    loadComponent: async () => await import('./features/prescriptions/prescriptions.component').then(m => m.PrescriptionsComponent)
  },
  {
    path: 'Search',
    canActivate: [authGuard, selectedZipGuard, selectedPlanGuard],
    loadComponent: async () => await import('./features/search/search.component').then(m => m.SearchComponent)
  },
  {
    path: 'Options',
    canActivate: [authGuard, selectedZipGuard, selectedPlanGuard, selectedDrugGuard],
    loadComponent: async () => await import('./features/options/options.component').then(m => m.OptionsComponent)
  },
  {
    path: 'Pharmacies',
    canActivate: [authGuard, selectedZipGuard, selectedPlanGuard, retailCostsSelectedGuard],
    loadComponent: async () => await import('./features/pharmacies/pharmacies.component').then(m => m.PharmaciesComponent)
  },
  {
    path: 'Account/Coverage',
    canActivate: [authGuard, selectedZipGuard, selectedPlanGuard, selectedDrugsGuard],
    loadComponent: async () => await import('./features/coverage/coverage.component').then(m => m.CoverageComponent)
  },
  {
    path: 'AnnualCostReport',
    canActivate: [authGuard, selectedZipGuard, selectedPlanGuard, selectedDrugsGuard],
    loadComponent: async () =>
      await import('./features/annual-cost-report/annual-cost-report.component').then(m => m.AnnualCostReportComponent)
  },
  {
    path: 'PharmacyDetails',
    canActivate: [authGuard, selectedZipGuard, selectedPlanGuard, retailCostsSelectedGuard, selectedPharmacyForDetailsGuard],
    loadComponent: async () => await import('./features/pharmacy-details/pharmacy-details.component').then(m => m.PharmacyDetailsComponent)
  }
];
